/**
 * Analytics helper.
 *
 * PostHog is loaded ONCE, by the snippet in public/index.html (window.posthog).
 * Do not `import posthog from "posthog-js"` / call posthog.init() in components:
 * a second instance on the same project double-counts pageviews and autocaptured
 * clicks. Calls made before the snippet finishes loading are queued by its stub.
 */
export function track(event, properties = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, properties);
    }
  } catch (e) {
    // analytics must never break the page
  }
}
